import { FC } from 'react';
import { Box, Flex, Spacer } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Card from 'components/_core/Card';
import SunshineIcon, { IconName } from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';

import locales from './locales';

export type InformationSectionItem = [string, string | null];

interface InformationSectionProps {
  iconName: IconName;
  items: InformationSectionItem[];
  secondaryItems?: InformationSectionItem[];
  onEdit?: () => void;
  title: string;
}

const InformationSection: FC<InformationSectionProps> = ({
  iconName,
  items,
  onEdit,
  secondaryItems,
  title,
}) => (
  <Card padding="0">
    <Card.Title
      backgroundColor="grey.100"
      borderBottomStyle="solid"
      borderBottomWidth="1px"
      borderColor="blackAlpha.100"
      borderTopRadius="radius-8"
      padding="space-16"
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center">
          <SunshineIcon color="primary" name={iconName} size="icon-20" />
          <Text fontWeight="weight-400" marginLeft="space-8" variant="primary">
            {title}
          </Text>
        </Flex>
        {onEdit ? (
          <Button onClick={onEdit} variant="inline-secondary">
            {locales.edit}
          </Button>
        ) : null}
      </Flex>
    </Card.Title>
    <Flex
      flex={1}
      flexDirection="column"
      paddingLeft="space-16"
      paddingTop="space-16"
    >
      {items.map(([label, value]) => (
        <Box key={label} marginBottom="space-16">
          <Text size="sm" variant="light">
            {label}
          </Text>
          <Text variant="primary">{value || '--'}</Text>
        </Box>
      ))}
      <Spacer />
    </Flex>
    {secondaryItems && secondaryItems.length > 0 ? (
      <Flex
        borderColor="blackAlpha.100"
        borderTopStyle="solid"
        borderTopWidth="1px"
        flex={1}
        flexDirection="column"
        paddingLeft="space-16"
        paddingTop="space-16"
      >
        {secondaryItems.map(([label, value]) =>
          value ? (
            <Box key={label} marginBottom="space-16">
              <Text size="sm" variant="light">
                {label}
              </Text>
              <Text variant="primary">{value}</Text>
            </Box>
          ) : null,
        )}
        <Spacer />
      </Flex>
    ) : null}
  </Card>
);

export default InformationSection;
